/* カートページカスタマイズ(ギフト処理はスニペットに記載) */

// ダイアログの表示/非表示制御

// ギフト選択中の場合、ダイアログを閉じて良いか確認
const confirmCloseDialog = () => {
    const checkHandbag = document.querySelector('#gift__chk-handbag'),
        checkNoshi = document.querySelector('#gift__chk-noshi'),
        checkWrapping = document.querySelector('#gift__chk-wrapping');

    if((checkHandbag && checkHandbag.checked )
        || (checkNoshi && checkNoshi.checked)
        || (checkWrapping && checkWrapping.checked)
    ){
        // ギフト選択中の場合、ダイアログを閉じて良いか確認
        if(!confirm('ギフトオプションは反映されませんがよろしいでしょうか')){
            return false;
        }

    }
    return true
}
// ダイアログ表示
const openCheckoutDialog = (event) => {
    event.preventDefault();

    const vh = window.innerHeight;
    document.querySelector("main").style.setProperty('--device-height', `${vh}px`);
    const target = document.getElementById(event.target.dataset.target);
    target.classList.add("open");
    document.body.classList.add('locked-scroll');
    const checkoutPlaceholderBtn = document.getElementById('checkout__button-placeholder--delivery');
    const outsideClose = (e) => {
      if (e.target == target) {
        if(target.id === "gift-dialog" && confirmCloseDialog() === false){
            return false    
        }
        target.classList.remove("open");
        document.body.classList.remove('locked-scroll');
        if(checkoutPlaceholderBtn){
            checkoutPlaceholderBtn.style.display = 'none !important';
        }
      }
    }
    if (!target.hasEventListener) {
        target.addEventListener('click', outsideClose);
        target.hasEventListener = true;
    }
    
    const deliveryDateLabel = document.querySelector('[for="shipping-day"]');
    if(target.id === "delivery-dialog" && deliveryDateLabel){
        localStorage.setItem('deliveryDialog', 'true');
        deliveryDateLabel.click();
        if(checkoutPlaceholderBtn){
            checkoutPlaceholderBtn.style.display = 'block';
        }
    }else if(target.id === "gift-dialog"){
        localStorage.setItem('giftDialog', 'true');
    }
}
// ダイアログ非表示
const closeCheckoutDialog = (event) => {
    event.preventDefault();
    const target = event.target.closest('.c-add-cart-announce-dialog__wrapper');
    const checkoutPlaceholderBtn = document.getElementById('checkout__button-placeholder--delivery');

    if(target.id === "gift-dialog" && confirmCloseDialog() === false){
        return false    
    }

    target.classList.remove("open");
    document.body.classList.remove('locked-scroll');
    if(target.id === "delivery-dialog"){
        localStorage.removeItem('deliveryDialog');
        if(checkoutPlaceholderBtn){
            checkoutPlaceholderBtn.style.display = 'none !important';
        }
    }else if(target.id === "gift-dialog"){
        localStorage.removeItem('giftDialog');
    }
}

// 配送日時指定の表示制御
document.addEventListener('DOMContentLoaded', () => {
    const vh = window.innerHeight;
    document.querySelector("main").style.setProperty('--device-height', `${vh}px`);

    // 初期表示時のダイアログ表示を削除
    // if(localStorage.getItem('deliveryDialog') === 'true'
    //     && document.getElementById('delivery-dialog')
    // ){
    //     document.getElementById('delivery-dialog').classList.add('open');
    //     document.body.classList.add('locked-scroll');
    // }else if(localStorage.getItem('giftDialog') === 'true'
    //     && document.getElementById('gift-dialog')
    // ){
    //     document.getElementById('gift-dialog').classList.add('open');
    //     document.body.classList.add('locked-scroll');
    // }
});

// 配送日時指定 Placeholderクリック時
const checkout_for_delivery = (event) => {
    const deliveryDay = document.querySelector('#shipping-day'),
        deliveryTime = document.querySelector('[name="attributes[希望配送時間]"]:checked'),
        checkoutBtn = document.querySelector('[name="checkout"]');

        event.target.classList.add('is-loading');

    if(deliveryDay && deliveryTime){
        fetch('/cart/update.js', { 
        method: 'POST', 
        headers: { 
            'Content-Type': 'application/json' 
        }, 
        body: JSON.stringify({
            attributes: {
            '希望配送日': deliveryDay.value,
            '希望配送時間': deliveryTime.value
            }
        }) 
        }) 
        .then(response => {      
            console.log(response);
        }) 
        .catch((error) => { 
            console.error('Error:', error); 
        })
        .finally(() => {
            checkoutBtn.click();
        });
    }else{
        checkoutBtn.click();
    }
}